<template xmlns="http://www.w3.org/1999/html">
  <v-flex xs12>
    <v-simple-table
      v-if="bookingChangelog"
      dense
      style="font-size: 11px !important;"
    >
      <template v-slot:default>
        <thead>
        <tr>
          <th>Sr. #</th>
          <th>Date</th>
          <th>Office user</th>
          <th>Type</th>
          <th>Notes</th>
          <th>Updates</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(change, index) in bookingChangelog.changes">
          <td>{{index+1}}</td>
          <td>{{ change.created_at }}</td>
          <td>
            <div v-if="change.office_user">
              {{ change.office_user.id + " " + change.office_user.name }}
            </div>
          </td>
          <td>{{ change.type }}</td>
          <td>{{ change.notes }}</td>
          <td>
              <table v-if="change.updates.length">
                <tbody>
                <template v-for="update in change.updates">
                  <tr :key="update.id">
                    <td>{{ update.field }}</td>
                    <td v-if="update.old_value" title="Previous value">
                      <v-chip small color="deep-orange lighten-4" >
                        {{ update.old_value }}
                      </v-chip>
                    </td>
                    <td v-if="update.new_value" title="New value">
                      <v-chip small color="blue lighten-3">
                        {{ update.new_value }}
                      </v-chip>
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-flex>
</template>

<script>
import moment from "moment";

export default {
  name: "BookingChangelog",
  components: {},

  props: {
    booking: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      changelogDialog: false
    }
  },
  watch: {
    booking () {
      this.fetchChangelog()
    }
  },
  computed: {
    bookingChangelog () {
      return this.$store.getters['booking/getBookingChangelog']
    },
    bookingId () {
      return this.booking ? this.booking.id : null
    }
  },
  methods: {
    openChangelogDialog() {
      this.changelogDialog = true
    },
    fetchChangelog() {
      this.$store.dispatch('booking/getBookingChangelog', this.bookingId)
    }
  },
  created() {
    this.fetchChangelog()
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.v-timeline-item {
  padding-bottom: 8px !important;
}

.v-timeline {
  padding-top: 8px !important;
}

tr[role="row"] {
  height: 64px !important;
}

.e-resource-column-wrap tr {
  height: 64px !important;
}

.timeline .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11px !important;
}

</style>
